// create
export const CREATE_REVERSAL_REQUEST = "CREATE_REVERSAL_REQUEST";
export const CREATE_REVERSAL_SUCCESS = "CREATE_REVERSAL_SUCCESS";
export const CREATE_REVERSAL_FAIL = "CREATE_REVERSAL_FAIL";

export const REVERSAL_CLEAR_ERROR = "REVERSAL_CLEAR_ERROR";